﻿import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'jax-edit-list',
    inputs: ['inputLabelResourceKey', 'id', 'itemsSource', 'selectedValue', 'displayMemeberName', 'selectedValuePropertyName', 'isDisabled', 'isMandatory'],
    templateUrl: './editlist.component.html'
})

export class EditlistComponent {
    isDisabled: boolean;
    displayMemeberName: string;
    selectedValue: any;
    inputLabelResourceKey;
    isMandatory: boolean;
    id: string;
    selectedValuePropertyName: string;
    private inputLabel;
    private _itemsSource;

    get itemsSource() {
        return this._itemsSource;
    }
    set itemsSource(value) {
        this._itemsSource = value;
        this.setDisplayMemberName(value);
    }

    @Output() selectedValueChange: any = new EventEmitter();


    selectedItemChange(value) {
        this.selectedValue = value;
        this.selectedValueChange.emit(value);
    }

    setDisplayMemberName(source: any[]) {
        if (!source)
            return;
        if (Array.isArray(source)) {
            if (this.displayMemeberName) {
                source.forEach(s => {
                    if (this.displayMemeberName)
                        s['displayMemeberName'] = s[this.displayMemeberName];
                    if (this.selectedValuePropertyName)
                        s['selectedValuePropertyName'] = s[this.selectedValuePropertyName];
                });
            }
        }
        else
            throw new Error('itemsSource must be iterable');
    }
}